import { render, staticRenderFns } from "./RightBarSwitcher.vue?vue&type=template&id=7f808b7a&scoped=true"
import script from "./RightBarSwitcher.vue?vue&type=script&lang=js"
export * from "./RightBarSwitcher.vue?vue&type=script&lang=js"
import style0 from "./RightBarSwitcher.vue?vue&type=style&index=0&id=7f808b7a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f808b7a",
  null
  
)

export default component.exports